import { EquipmentType } from "@/survey";
import { sanitizeSvg } from "@/sanitizeSvg";
import {
  guessEquipmentIconKey,
  makeSvgDataUrl,
  renderEquipmentIconSvg,
  renderStandardEquipmentTypeIconSvg,
  getStandardEquipmentIconKey
} from "@/equipmentIconLibrary";

function markerSizeForZoom(zoom: number | undefined): number {
  if (zoom === undefined) {
    return 28;
  }
  return Math.max(22, Math.min(42, Math.round(zoom * 1.6)));
}

function iconSvgForEquipmentType(equipmentType: EquipmentType): string {
  if (getStandardEquipmentIconKey(equipmentType.name) !== null) {
    return renderStandardEquipmentTypeIconSvg(
      equipmentType.name,
      equipmentType.color || "#ff1f1f"
    );
  }

  const sanitizedSvg = sanitizeSvg(equipmentType.iconSvg);
  if (sanitizedSvg.length > 0) {
    return sanitizedSvg;
  }
  return renderEquipmentIconSvg(
    guessEquipmentIconKey(equipmentType.name),
    equipmentType.color || "#ff1f1f"
  );
}

export function getEquipmentMarkerIcon(
  equipmentType: EquipmentType,
  googleMaps: any,
  zoom: number | undefined
): any {
  const size = markerSizeForZoom(zoom);
  return {
    url: makeSvgDataUrl(iconSvgForEquipmentType(equipmentType)),
    scaledSize: new googleMaps.maps.Size(size, size),
    anchor: new googleMaps.maps.Point(size / 2, size / 2),
    optimized: false
  };
}
